import * as React from 'react'
import { toast } from 'react-toastify'
import { LoadingButton } from '@mui/lab'
import Button from '@mui/material/Button'
import DialogContent from '@mui/material/DialogContent'
import { useMutation } from '@tanstack/react-query'
import RewardsAPI from 'api/faber/RewardsAPI'
import { AxiosError } from 'axios'
import { BootstrapDialog, BootstrapDialogTitle } from 'common/AbstractModal/BootstrapDialog'
import { FaberResponse } from 'helpers/backendTypes'
import OrbitSession from 'hooks/useCookies'

import NewRuleForm from './AddRewardRuleForm'


export default function AddRewardRuleDialog() {
  const [open, setOpen] = React.useState(false)
  const faberToken = OrbitSession.get('faberToken')

  const handleClickOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  const { mutate: refreshMV, isLoading: isRefreshing } = useMutation(
    () => RewardsAPI.refreshMaterializedView(faberToken),
    {
      onSuccess: () => {
        toast.success('Materialized view refreshed successfully')
      },
      onError: (err: AxiosError<FaberResponse>) => {
        const message = err.response?.data?.message
          ? err.response.data.message
          : 'Failed to refresh Materialized view'
        toast.error(message)
      },
    }
  )

  return (
    <div style={{ display: 'flex', gap: '8px' }}>
      <Button variant='contained' onClick={handleClickOpen}>
        Add Reward Rule
      </Button>
      <LoadingButton
        variant='contained'
        loading={isRefreshing}
        onClick={() => refreshMV()}
      >
        Refresh Materialized View
      </LoadingButton>
      <BootstrapDialog
        fullWidth
        maxWidth='md'
        onClose={handleClose}
        aria-labelledby='customized-dialog-title'
        open={open}
      >
        <BootstrapDialogTitle onClose={handleClose}>
          Add a new reward rule
        </BootstrapDialogTitle>
        <DialogContent dividers sx={{ height: '60vh' }}>
          <NewRuleForm handleClose={handleClose} />
        </DialogContent>
      </BootstrapDialog>
    </div>
  )
}
